export default __webpack_public_path__ + "static/media/img-24.37ab5e4d.jpeg";